import { useGetScanQuery } from "api/scan/queries/useGetScanQuery";
import { useGetVirtualTourReferenceMeasurements } from "api/virtual-tour/queries/useGetVirtualTourReferenceMeasurements";

// type ExtendedScan = {
//   scan: Scan;
// } & {
//   isScanLoading: boolean;
//   scanError: Error | null;
//   input: ScanInput | null;
//   outputs: ScanOutput[] | null;
//   virtualTourOutput: ScanOutput | undefined;
//   referenceMeasurements: VirtualTourReferenceMeasurement[] | undefined;
//   isCalibrated: boolean | null;
// };

// const currentActiveScanAtom = atom<ExtendedScan | null>(null);

export const useCurrentActiveScan = (scanId: string) => {
  const {
    data: scan,
    isLoading: isScanLoading,
    error: scanError,
  } = useGetScanQuery(scanId);

  const input = scan?.input;
  const outputs = scan?.outputs;

  const virtualTourOutput = outputs?.find(
    (output) => output.type === "VIRTUALTOUR"
  );

  const { data: referenceMeasurements } =
    useGetVirtualTourReferenceMeasurements(
      virtualTourOutput?.virtualTour?.id || ""
    );

  const isScanCalibratedInDB = scan?.calibrated ?? false;

  const isCalibrated: boolean | null =
    virtualTourOutput && referenceMeasurements
      ? referenceMeasurements.length > 0
      : null;

  return {
    currentActiveScan: {
      scan,
      isScanLoading,
      scanError,
      input,
      outputs,
      virtualTourOutput,
      referenceMeasurements,
      isCalibrated,
      isScanCalibratedInDB,
    },
    // resetCurrentActiveScan,
  };
};
